import { assertProjectDocument, isRecord } from "./model";
import type { ProjectDocumentV2 } from "./model";

export interface LegacyProjectEntries {
  manifest: string;
  project: string;
}

/** Import only. New projects are always written with the engine's own codec. */
export function decodeLegacyProject(
  entries: LegacyProjectEntries,
): ProjectDocumentV2 {
  const manifest: unknown = JSON.parse(entries.manifest);
  if (
    !isRecord(manifest) ||
    manifest.format !== "3dcd-project" ||
    Number(manifest.formatVersion) !== 1
  ) {
    throw new Error("Неподдерживаемая версия файла .3dcd.");
  }
  const project: unknown = JSON.parse(entries.project);
  assertProjectDocument(project);
  return project;
}
